import { fg } from '@atlaskit/platform-feature-flags';
import type { Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

/**
 * Returns `true` when an agent is a marathon / max agent.
 */
export const isMarathonAgent = (agent?: Agent): boolean => {
	if (!fg('rovo_marathon_as_agent_enabled')) {
		return false;
	}
	return agent?.execution_config?.execution_tier === 'TIER_2' || false;
};
